import opineoQualitySvg from 'assets/images/icons/certyfikat_opineo_bez_napisu.svg';
import inPostBadge from 'assets/images/inpost-desktop.webp';
import Image from 'atomic/image';
import Tooltip from 'atomic/tooltip/tooltip';
import getBadge from 'helpers/get-badge';
import getOpineoBadgeDescription from 'helpers/get-opineo-badge-description';
import { BadgeType } from 'interfaces/dealer-opinions.interface';
import React from 'react';
import Link from '../../../../../../views/atomic/link/link';
import { SeoLinkRelEnum } from 'modules/seo-module/interfaces/seo-link-rel.enum';

import './dealer-badges.scss';

interface DealerBadgesProps {
    authorizedConfig?: {
        url: string;
        title?: string;
        image: string;
    };
    dealerBadge?: {
        name: string;
        type: BadgeType;
    };
    badges: {
        fastPayment?: boolean;
        isOpineoQuality?: boolean;
        isQuality?: boolean;
        inPost?: boolean;
        freeDelivery?: boolean;
        delivery24?: boolean;
        promoText?: string;
    };
}

const DealerBadges: React.FC<DealerBadgesProps> = ({ dealerBadge, authorizedConfig, badges }) => {
    return <div className="dealer-info__dealer-badges">
        {authorizedConfig
            && <span className="dealer-info__dealer-badges__badge">
                <Tooltip
                    positions={['top']}
                    trigger={<span>
                        <Image className="dealer-info__dealer-badges__badge__image dealer-info__dealer-badges__badge__image-help"
                            src={authorizedConfig.image}
                            alt={authorizedConfig.title || 'Autoryzowany sklep producenta'}
                            title={authorizedConfig.title || 'Autoryzowany sklep producenta'}
                            height={30} show={true}
                            loading="lazy"
                        /></span>}

                    title={<>
                        {authorizedConfig.title || 'Autoryzowany sklep producenta'}
                    </>}
                >
                    <p className="tooltip-text">
                        Sklep który jest oficjalnym dealerem producenta. Kupując tutaj masz pewność oryginalności produktu.
                        {authorizedConfig.url && <p>
                            <br />  <br />
                            <Link href={authorizedConfig.url} rel={SeoLinkRelEnum.NOOPENER_NOREFERRER} styles={{ padding: 0 }}>Przeczytaj więcej tutaj</Link>
                        </p>
                        }
                    </p>
                </Tooltip>
                <span className="dealer-info__dealer-badges__badge__title">
                    {authorizedConfig.title || 'Autoryzowany sklep'}
                </span>
            </span>
        }

        {badges.inPost
            && <span className="dealer-info__dealer-badges__badge">
                <Tooltip
                    positions={['top']}
                    trigger={<span>
                        <Image className="dealer-info__dealer-badges__badge__image dealer-info__dealer-badges__badge__image-help"
                            src={inPostBadge}
                            alt="Wysyłka z inPost"
                            title="Wysyłka z inPost"
                            height={40} show={true}
                            loading="lazy"
                        /></span>}

                    title={<>
                        Wysyłka z inPost
                    </>}
                >
                    <p className="tooltip-text">
                        Sklep korzysta z usług inPost.
                    </p>
                </Tooltip>
                <span className="dealer-info__dealer-badges__badge__title">
                    Wysyłka z inPost
                </span>
            </span>
        }

        {badges.isOpineoQuality
            && <span className="dealer-info__dealer-badges__badge">
                <Tooltip
                    positions={['top']}
                    trigger={<span>
                        <Image className="dealer-info__dealer-badges__badge__image dealer-info__dealer-badges__badge__image-help"
                            src={opineoQualitySvg} alt="Certyfikat Opineo"
                            title="Certyfikat Opineo"
                            height={55} show={true}
                            loading="lazy"
                        /></span>}

                    title={<>
                        Certyfikat Opineo
                    </>}
                >
                    <div className="tooltip-text dealer-info__dealer-badges__badge-tooltip-text">
                        <strong>Sprawdzamy taki sklep, aby upewnić się, że:</strong>

                        <ul>
                            {/* eslint-disable-next-line max-len */}
                            <li>umieszcza na swojej stronie internetowej informacje/dane rejestrowe, dane kontaktowe, jest obecny w odpowiednich rejestrach dla prowadzonej działalności</li>
                            <li>ma siedzibę prowadzenia działalności gospodarczej, którą da się łatwo zlokalizować</li>
                            <li>dane identyfikujące sklep internetowy są łatwo dostępne i przejrzyste</li>
                            <li>dysponuje aktywną domeną sklepu internetowego - działającą stroną WWW</li>
                            <li>zapewnia tryb reklamacyjny, o którym przejrzyście informuje swoich klientów</li>
                            <li>publikuje politykę prywatności</li>
                            {/* eslint-disable-next-line max-len */}
                            <li>zapewnia regulamin swoich usług (np. regulamin sklepu internetowego), a także informuje w sposób czytelny o kosztach dostawy, cenach, walucie, terminie realizacji zamówienia, możliwościach i terminach zwrotu bądź odstąpienia od umowy</li>
                        </ul>

                        <br />  <br />
                        <strong>W swojej decyzji weryfikacyjnej uwzględniamy również, czy:</strong>
                        <ul>
                            <li>zapewnia klientom informacje, o których mowa wyżej w odpowiednim zakresie i we właściwy sposób</li>
                            <li>ceny w jego ofercie nie odbiegają w istotny dla wiarygodności oferty sposób od cen rynkowych</li>
                        </ul>
                        <br />  <br />
                        <Link href="https://odznaki.opineo.pl/" rel={SeoLinkRelEnum.NOOPENER_NOREFERRER} styles={{ padding: 0 }}>Przeczytaj więcej o certyfikacie tutaj</Link>
                    </div>
                </Tooltip>

                <span className="dealer-info__dealer-badges__badge__title">
                    Certyfikat Opineo
                </span>
            </span >}

        {
            dealerBadge && <span className="dealer-info__dealer-badges__badge">
                <Tooltip
                    positions={['top']}
                    trigger={<span>
                        <Image className="dealer-info__dealer-badges__badge__image dealer-info__dealer-badges__badge__image-help"
                            src={getBadge(dealerBadge.type)}
                            alt={dealerBadge.name}
                            title={dealerBadge.name}
                            height={55} show={true}
                            loading="lazy"
                        /></span>}

                    title={<>
                        {dealerBadge.name} &quot;Słucham Swoich Klientów&quot;
                    </>}
                >
                    <div className="tooltip-text dealer-info__dealer-badges__badge-tooltip-text">
                        <ul>
                            {getOpineoBadgeDescription(dealerBadge.type).map((paragraph, i) => <li key={`paragraph_${i}`}>{paragraph}</li>)}
                        </ul>
                        <br />  <br />
                        <Link href="https://odznaki.opineo.pl/" rel={SeoLinkRelEnum.NOOPENER_NOREFERRER} styles={{ padding: 0 }}>Przeczytaj więcej o odznakach tutaj</Link>
                    </div>
                </Tooltip>

                <span className="dealer-info__dealer-badges__badge__title">
                    {dealerBadge.name}
                </span>
            </span>
        }
    </div >;
};

export default DealerBadges;
